import React, { useEffect, useRef, useState } from "react";
import "./Sidebar.css";
import { Link } from "react-router-dom";
import { database } from "../firebase"; // Import Firebase database
import { ref, get } from "firebase/database";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const sidebarRef = useRef(null);
  const [username, setUsername] = useState("User");
  const token = localStorage.getItem("token");

  // Fetch username from Firebase using token
  useEffect(() => {
    const fetchUsername = async () => {
      if (token) {
        try {
          // Assuming token is stored as user's UID
          const userRef = ref(database, `users/${token}/name`);
          const snapshot = await get(userRef);
          if (snapshot.exists()) {
            setUsername(snapshot.val()); // Set username from Firebase
          }
        } catch (error) {
          console.error("Error fetching username:", error);
        }
      }
    };

    fetchUsername();
  }, [token]);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        toggleSidebar();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);

  return (
    <div ref={sidebarRef} className={`new-sidebar-container ${isOpen ? "new-sidebar-open" : ""}`}>
      <button className="new-sidebar-close-btn" onClick={toggleSidebar}>✖</button>
      <ul className="new-sidebar-menu">
        {token ? (
          <>
            <li><span>Welcome, {username}</span></li>
            <li><Link to="/" onClick={toggleSidebar}>Home</Link></li>
            <li><Link to="/orders" onClick={toggleSidebar}>Order</Link></li>
            <li><Link to="/account" onClick={toggleSidebar}>Account</Link></li>
            <li onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("username");
              toggleSidebar();
              window.location.reload();
            }}>Logout</li>
          </>
        ) : (
          <>
            <li><Link to="/login" onClick={toggleSidebar}>Sign in</Link></li>
            <li><Link to="/" onClick={toggleSidebar}>Home</Link></li>
            <li><Link to="/order" onClick={toggleSidebar}>Order</Link></li>
            <li><Link to="/account" onClick={toggleSidebar}>Account</Link></li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
